import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthShell, authPrimaryButtonClass } from '@/components/auth/AuthShell';
import { Button } from '@/components/ui/button';
import {
  useAuth,
  ACCOUNT_DEACTIVATED_TITLE,
  ACCOUNT_DEACTIVATED_DESCRIPTION,
} from '@/contexts/AuthContext';

/**
 * Shown to a team member an admin deactivated (#1390) whose browser still holds
 * a session: a clear dead end with a way out, never a half-loaded app.
 */
export function AccountDeactivated() {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  return (
    <AuthShell title={ACCOUNT_DEACTIVATED_TITLE} subtitle={ACCOUNT_DEACTIVATED_DESCRIPTION}>
      <div data-testid="account-deactivated" className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Your jobs, hours and pay are still on record. Once your admin reactivates you, sign in as usual.
        </p>
        <Button
          type="button"
          className={authPrimaryButtonClass}
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            await signOut();
            navigate('/auth', { replace: true });
          }}
        >
          Sign out
        </Button>
      </div>
    </AuthShell>
  );
}
